/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
import React, { lazy, useState } from "react";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { Footer, AsideBar, ProtectedRoute, GuestRoute } from "./components";
import "react-toastify/dist/ReactToastify.css";
import { HomeDashboard } from "./screens/homeDashboard/homeDashboard";

const Auth = lazy(() => import("./screens/auth/auth"));
// const Employees = lazy(() => import("./screens/employees/employees"));
const CreateEmployee = lazy(() => import("./screens/createEmployee/createEmployee"));
const CreateVehicle = lazy(() => import("./screens/createVehicle/createVehicle"));
const EditEmployee = lazy(() => import("./screens/editEmployee/editEmployee"));
const DetailsEmployee = lazy(() => import("./screens/detailsEmployee/detailsEmployee"));
const AllTasks = lazy(() => import("./screens/allTasks/allTasks"));
const CompletedTasks = lazy(() => import("./screens/completedTasks/completedTasks"));
const StartedTasks = lazy(() => import("./screens/startedTasks/startedTasks"));
const ExpiredLicense = lazy(() => import("./screens/expiredLicense/expiredLicense"));
const ExpiredCarInsurance = lazy(() => import("./screens/expiredCarInsurance/expiredCarInsurance"));
const ExpiredContracts = lazy(() => import("./screens/expiredContracts/expiredContracts"));
const NewCreatedContracts = lazy(() => import("./screens/newCreatedContracts/newCreatedContracts"));
const CustomersComplains = lazy(() => import("./screens/customersComplains/customersComplains"));
const QualityComplains = lazy(() => import("./screens/qualityComplains/qualityComplains"));
const TaskComplains = lazy(() => import("./screens/taskComplains/taskComplains"));
const NotFound = lazy(() => import("./screens/notFound/notFound"));
const SearchCustomers = lazy(() => import("./screens/searchCustomers/searchCustomers"));
const SearchEmployees = lazy(() => import("./screens/searchEmployees/searchEmployees"));
const SearchVehicles = lazy(() => import("./screens/searchVehicles/searchVehicles"));
const CreateCustomer = lazy(() => import("./screens/createCustomer/createCustomer"));
const DetailsCustomer = lazy(() => import("./screens/customerDetails/CustomerDetails"));
const EditCustomer = lazy(() => import("./screens/editCustomer/editCustomer"));
const CreateIdividual = lazy(() => import("./screens/createIndividual/createIndividual"));
const EditIdividual = lazy(() => import("./screens/editIndividual/editIndividual"));
const DetailsIdividual = lazy(() => import("./screens/detailsIndividual/detailsIndividuals"));
const EditVehicle = lazy(() => import("./screens/editVehicle/editVehicle"));
const ViewVehicle = lazy(() => import("./screens/viewVehicle/viewVehicle"));
const SingleTask = lazy(() => import("./screens/singleTask/singleTask"));
const IndividualTask = lazy(() => import("./screens/individaulTask/individualTask"));
const TaskCompaints = lazy(() => import("./screens/complaintsTask/complaintsTask"));
const CustomerComplaints = lazy(() => import("./screens/complaintsCustomer/complaintsCustomer"));
const QualityComlaints = lazy(() => import("./screens/complaintsquality/compaintsQuality"));
const Configuration = lazy(() => import("./screens/configuration/configuration"));
const Tasks = lazy(() => import("./screens/Tasks/Tasks"));
const Operation = lazy(() => import("./screens/Tasks/operation/operation"));
const Calendar = lazy(() => import("./screens/Tasks/Calendar/Calendar"));
const MonthlyGenerate = lazy(() => import("./screens/Tasks/monthlyGenerate/monthlyGenerate"));
const NoOpenTasks = lazy(() => import("./screens/notOpenTasks/noOpenTasks"));
const HandlingCoverage = lazy(() => import("./screens/handlingCoverage/handlingCoverage"));
const Attendance = lazy(() => import("./screens/attendance/Attendance"));
const TaskReport = lazy(() => import("./screens/TaskReport/TaskReport"));
const Profile = lazy(() => import("./screens/Profile/profile"));
const Contract = lazy(() => import("./screens/all-Contract/contract"));

function App() {
  const { isExact } = useRouteMatch("/");
  // const [employeeId, setEmployeeId] = useState();
  const [vehicleId, setVehicleId] = useState();
  const [individualCustomresId, setindividualCustomresId] = useState();
  const [tasks, setTasks] = useState([]);
  const [completedVisits, setCompletedVisits] = useState([]);
  const [notOpenedVisits, setNotOpenedVisits] = useState([]);
  const [startVisits, setStartVisits] = useState([]);

  return (
    <>
      {isExact ? null : <AsideBar />}
      <Switch>
        <GuestRoute exact path="/">
          <Auth />
        </GuestRoute>
        <ProtectedRoute path="/profile">
          <Profile />
        </ProtectedRoute>
        <ProtectedRoute exact path="/home-dashboard">
          <HomeDashboard
            tasks={tasks}
            setTasks={setTasks}
            completedVisits={completedVisits}
            setCompletedVisits={setCompletedVisits}
            notOpenedVisits={notOpenedVisits}
            setNotOpenedVisits={setNotOpenedVisits}
            startVisits={startVisits}
            setStartVisits={setStartVisits}
          />
        </ProtectedRoute>
        <ProtectedRoute path="/not-opened-tasks">
          <NoOpenTasks notOpenedVisits={notOpenedVisits} />
        </ProtectedRoute>
        <ProtectedRoute path="/search-customers">
          <SearchCustomers
            individualCustomresId={individualCustomresId}
            setindividualCustomresId={setindividualCustomresId}
          />
        </ProtectedRoute>
        <ProtectedRoute path="/search-employees">
          <SearchEmployees
          //  setEmployeeId={setEmployeeId} employeeId={employeeId}
          />
        </ProtectedRoute>
        <ProtectedRoute path="/search-vehicles">
          <SearchVehicles vehicleId={vehicleId} setVehicleId={setVehicleId} />
        </ProtectedRoute>
        <ProtectedRoute path="/create-comercial-customer">
          <CreateCustomer />
        </ProtectedRoute>
        <ProtectedRoute path="/edit-comercial-customer">
          <EditCustomer />
        </ProtectedRoute>
        <ProtectedRoute path="/view-comercial-customer">
          <DetailsCustomer />
        </ProtectedRoute>
        <ProtectedRoute path="/create-individual-customer">
          <CreateIdividual individualCustomresId={individualCustomresId} />
        </ProtectedRoute>
        <ProtectedRoute path="/edit-individual-customer">
          <EditIdividual individualCustomresId={individualCustomresId} />
        </ProtectedRoute>
        <ProtectedRoute path="/view-individual-customer">
          <DetailsIdividual individualCustomresId={individualCustomresId} />
        </ProtectedRoute>
        <ProtectedRoute path="/create-employee">
          <CreateEmployee />
        </ProtectedRoute>
        <ProtectedRoute path="/edit-employee">
          <EditEmployee />
        </ProtectedRoute>
        <ProtectedRoute path="/details-employee">
          <DetailsEmployee />
        </ProtectedRoute>
        <ProtectedRoute path="/create-vehicle">
          <CreateVehicle vehicleId={vehicleId} />
        </ProtectedRoute>
        <ProtectedRoute path="/edit-vehicle">
          <EditVehicle vehicleId={vehicleId} />
        </ProtectedRoute>
        <ProtectedRoute path="/view-vehicle">
          <ViewVehicle vehicleId={vehicleId} />
        </ProtectedRoute>
        <ProtectedRoute path="/Handling-Coverage">
          <HandlingCoverage />
        </ProtectedRoute>
        <ProtectedRoute path="/tasks">
          <Tasks />
        </ProtectedRoute>
        <ProtectedRoute path="/Operation">
          <Operation />
        </ProtectedRoute>
        <ProtectedRoute path="/Calendar">
          <Calendar />
        </ProtectedRoute>
        <ProtectedRoute path="/monthly-generate">
          <MonthlyGenerate />
        </ProtectedRoute>
        <ProtectedRoute path="/single-task">
          <SingleTask />
        </ProtectedRoute>
        <ProtectedRoute path="/individual-task">
          <IndividualTask />
        </ProtectedRoute>
        <ProtectedRoute path="/Task-Compaints">
          <TaskCompaints />
        </ProtectedRoute>
        <ProtectedRoute path="/Customer-Complaints">
          <CustomerComplaints />
        </ProtectedRoute>
        <ProtectedRoute path="/quality-Complaints">
          <QualityComlaints />
        </ProtectedRoute>
        <ProtectedRoute exact path="/Configuration">
          <Configuration />
        </ProtectedRoute>
        <ProtectedRoute exact path="/all-tasks">
          <AllTasks tasks={tasks} />
        </ProtectedRoute>
        <ProtectedRoute exact path="/completed-tasks">
          <CompletedTasks completedVisits={completedVisits} />
        </ProtectedRoute>
        <ProtectedRoute exact path="/started-tasks">
          <StartedTasks startVisits={startVisits} />
        </ProtectedRoute>
        <ProtectedRoute exact path="/expired-license">
          <ExpiredLicense />
        </ProtectedRoute>
        <ProtectedRoute exact path="/expired-car-insurance">
          <ExpiredCarInsurance />
        </ProtectedRoute>
        <ProtectedRoute exact path="/expired-contracts">
          <ExpiredContracts />
        </ProtectedRoute>
        <ProtectedRoute exact path="/new-created-contracts">
          <NewCreatedContracts />
        </ProtectedRoute>
        <ProtectedRoute exact path="/customers-complains">
          <CustomersComplains />
        </ProtectedRoute>
        <ProtectedRoute exact path="/quality-complains">
          <QualityComplains />
        </ProtectedRoute>
        <ProtectedRoute exact path="/Attendance">
          <Attendance />
        </ProtectedRoute>
        <ProtectedRoute exact path="/View-Report">
          <TaskReport />
        </ProtectedRoute>
        <ProtectedRoute exact path="/task-complains">
          <TaskComplains />
        </ProtectedRoute>
        <ProtectedRoute exact path="/Contract">
          <Contract />
        </ProtectedRoute>
        <Route exact path="/404">
          <NotFound />
        </Route>
        <Redirect from="*" to="/404" />
      </Switch>
      {isExact ? null : <Footer />}
    </>
  );
}
export default App;
